import type { IUnifiedOnboardingStatusResponse } from './onboarding.types'

import { optimoPrivateApi } from '@/api/axios/axiosInstance'
import { endpoints } from '@/api/endpoints'

/**
 * Fetch unified onboarding status (employee + optional organization).
 *
 * - Requires authenticated Optimo token (private API)
 * - Returns employee intake status for the current user
 * - Includes organization block only if the caller is authorized
 */
export const getUnifiedOnboardingStatus = async (): Promise<IUnifiedOnboardingStatusResponse> => {
    const { data } = await optimoPrivateApi.get<IUnifiedOnboardingStatusResponse>(endpoints.onboarding.status)
    return data
}
